module.exports = __webpack_public_path__ + "media/tk-sound-halloween.b561378e.ogg";